// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Feed-module--wrapper--3k2Sw"};